import React from 'react';
import type { FC } from 'react';

import type { LoadableType } from '@confluence/loadable';
import { LoadableAfterPaint } from '@confluence/loadable';
import { SuspenseWithDataFetcher } from '@confluence/query-preloader-tools/entry-points/SuspenseWithDataFetcher.ts';

import { EndOfPageRecPlaceholderContainer } from './SharedComponents.tsx';
import type { EndOfPageRecommendationProps } from './EndOfPageRecommendation.tsx';

export const EndOfPageRecommendationLoader: LoadableType<EndOfPageRecommendationProps> =
	LoadableAfterPaint({
		loader: async () =>
			(
				await import(
					/* webpackChunkName: "loadable-EndOfPageRecommendation" */ './EndOfPageRecommendation.tsx'
				)
			).EndOfPageRecommendation,
	});

export const EndOfPageRecommendationFinalLoader: FC<EndOfPageRecommendationProps> = (props) => {
	// Uses EndOfPageRecommendationLoader (LoadableAfterPaint) rather than a LoadableActivatable
	// SCROLL_INTO_VIEW variant: that trigger fires setIsInViewport() synchronously via a ref callback
	// during React's commit/hydration phase, causing React error #421 when nested inside a
	// SuspenseWithDataFetcher boundary while scheduleSyncHydration is active.
	return (
		<SuspenseWithDataFetcher
			dataFetcherName="end-of-page-recommendations"
			fallback={<EndOfPageRecPlaceholderContainer />}
		>
			<EndOfPageRecommendationLoader {...props} />
		</SuspenseWithDataFetcher>
	);
};
